import axios from 'axios'
import qs from 'qs'

const HTTP_DEV = false
const HTTPS = HTTP_DEV
  ? 'https://dealer-test.360che.com'
  : 'https://dealer.360che.com'

const ajax = ({ url, params, type }) => {
  params.ts = +new Date()
  if (type === 'POST') {
    return axios.post(`${HTTPS}/${url}`, qs.stringify(params))
  } else {
    return axios.get(`${HTTPS}/${url}`, {
      params: params
    })
  }
}

export { ajax, HTTPS }



// WEBPACK FOOTER //
// ./src/api/ajax.js